import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 13h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1M20 17h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1M16 19h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26 4c.53 0 1.03.21 1.41.59h.01c.38.37.59.88.59 1.41v13.58c0 .26-.05.51-.15.76-.01 0-.01.02-.01.02q-.005.01-.012.02-.017.02-.018.04c-.09.2-.22.39-.38.56l-6.43 6.43c-.17.17-.36.29-.57.39q-.01.005-.02.012-.02.016-.04.018c-.01.01-.02.02-.03.02q-.36.15-.75.15H6c-.53 0-1.03-.22-1.41-.59S4 26.53 4 26V6c0-.53.22-1.03.59-1.41S5.47 4 6 4zm0 2H6v20h13v-6c0-.55.45-1 1-1h6zm-5 18.59L24.59 21H21z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCreditMemos = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCreditMemos);
export default Memo;
